import './PublicPostPage.css';

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useGettingPostInfo from '../hooks/useGettingPostInfo';
import useGettingPost from '../hooks/useGettingPost';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import PayloadParserFactory from '../components/payload/PayloadParserFactory';
import EditText from '../../b2b-common/EditText';
import CustomButton from '../../b2b-common/CustomButton';
import useDeobfuscatePostId from '../hooks/useDeobfuscatePostId';

const PublicPostPage = () => {
    const { postId: obfuscatedPostId } = useParams();
    const postId = useDeobfuscatePostId(obfuscatedPostId, 435003);
    const { postInfo } = useGettingPostInfo(postId);
    const [form, setForm] = useState({password: null});
    const [shouldFetchPost, setShouldFetchPost] = useState(false);
    const { post } = useGettingPost(shouldFetchPost ? postId : null, form.password);
    const [locale, setLocale] = useState(null);
    const { t } = useB2BTranslation('b2b-social', locale);

    const [isPasswordRequired, setIsPasswordRequired] = useState(null);
    const [showPasswordModal, setShowPasswordModal] = useState(false);

    useEffect(() => {
        if (postInfo) {
            if (!postInfo.enabled || postInfo.expired) {
                return;
            }
            if (locale !== postInfo.locale) {
                setLocale(postInfo.locale);
            }
            if (postInfo.privateInstance && !isPasswordRequired) {
                setIsPasswordRequired(true);
                setShowPasswordModal(true);
            } else {
                setShouldFetchPost(true);
            }
        }
    }, [postInfo]);

    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        setIsPasswordRequired(false);
        setShouldFetchPost(true);
        setShowPasswordModal(false);
    };

    useEffect(() => {
        console.log(post);
    }, [post]);

    console.log(postInfo);
    if (!postInfo) {
        return <div>Loading...</div>;
    }

    if (!postInfo.enabled || postInfo.expired) {
        return <div>Post is not available</div>;
    }

    if (showPasswordModal) {
        return (
            <div className="public-post-page">
                <h2>{t('This post is private')}</h2>
                <div className="password-field">
                    <EditText label={t('Password')}
                        object={form}
                        setObjectField={setForm}
                        objectField={'password'}
                        type='password'
                    />
                    <CustomButton label={t('Submit')} onClick={handlePasswordSubmit} />
                </div>
                <p>{t('If you don\'t know the pass key, please contact your site administrator.')}</p>
            </div>
        );
    }

    return (
        post && (
            <PayloadParserFactory post={post} />
        )
    );
}

export default PublicPostPage;